var React = require('react');

function ChevronLeftAlternative (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.06872 16.472L1.1916 9.29441C1.02375 9.1207 0.940397 8.89553 0.940397 8.6713C0.940397 8.44707 1.02375 8.22171 1.1916 8.04819L8.06872 0.870589C8.41246 0.51025 8.98291 0.498528 9.34198 0.8436C9.70349 1.18633 9.71525 1.7593 9.36897 2.11724L3.059 8.70515L9.3679 15.2254C9.71416 15.5822 9.7024 16.1561 9.3409 16.499C8.98179 16.8442 8.41051 16.8322 8.06872 16.472Z","fill":"currentColor"}));
}

ChevronLeftAlternative.defaultProps = {"width":"10","height":"17","viewBox":"0 0 10 17","fill":"none"};

module.exports = ChevronLeftAlternative;

ChevronLeftAlternative.default = ChevronLeftAlternative;
